// /*
//  * Public API Surface of components
//  */

// tabs
export * from './lib/tabs/tabs.component';
export * from './lib/tabs/tab.directive';
export * from './lib/tabs/tabs.module';

// /*
//  *
//  TABLE MODULE
//  *
//  */

export * from './lib/table-module/table.module';
// export * from './lib/table-module/table.component';
export * from './lib/table-module/admin-table.component';
export * from './lib/table-module/interfaces/on-create.interface';
export * from './lib/table-module/interfaces/on-delete.interface';
export * from './lib/table-module/interfaces/on-update.interface';

// /*
//  * GRAPH MODULE
//  */
//  export * from './lib/graph-module/graph.module';
//  export * from './lib/graph-module/chart-builder.model';
//  export * from './lib/graph-module/chart-configurations';
//  export * from './lib/graph-module/chart.model';
//  export * from './lib/graph-module/graph.component';

// EXPORT THEME

// export * from './lib/@theme/theme.module';
// export * from './lib/@theme/layouts/one-column/one-column.layout';

 // NEW VERSIONNNNNNNN
export * from './lib/admin-app/admin-app.module';
export * from './lib/admin-app/admin-app.abstract';
export * from './lib/admin-app/directives/admin-main.directive';
export * from './lib/admin-app/services/lazy-load.service';
export * from './lib/admin-app/admin-app-routing.module';
export * from './lib/admin-app/admin-app.component';
export * from './lib/admin-app/components/pages.component';




// export auth

export * from './lib/admin-auth/admin-auth.module';
export * from './lib/admin-auth/login/login.component';
